import {
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  material_code,
  amount,
  unit,
  remarks,
} from '@/table/Job/SubJob/base';

export default {
  types: {
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    material_code,
    amount: {
      ...amount,
      name: 'จำนวนทั้งหมด',
      width: '6rem',
    },
    qc_store_amount: {
      name: 'จำนวนที่มี',
      width: '6rem',
      class: 'text-right',
    },
    addonAmount: {
      name: 'จำนวนที่ดำเนินการ',
      width: '7rem',
      class: 'text-right',
    },
    unit,
    remarks,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'qc_store_amount',
    'unit',
  ],
};
